<template lang="html">
    <v-form v-model="isValid" ref="form" @submit.prevent="">
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12>
                    <v-select ref="status" label="Statut"
                    autocomplete
                    required
                    chips
                    clearable
                    :items="projectStatuses"
                    v-model="model.status">
                        <template slot="selection" slot-scope="data">
                                {{data.item.label}}
                            </template>
                        <template slot="item" slot-scope="data">
                                <template v-if="typeof data.item === 'object'">
                                    {{data.item.label}}
                                </template>
                        </template>
                    </v-select>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
import { ProjectStatuses } from '../../../config/enum/ProjectStatuses'

export default {
    props: {
        items: {
            required: false,
        },
        params: {
            required: false,
        }
    },
	data() {
		return {
			title: 'Changer le status',
			icon: 'edit',

            isValid:false,

			model: {
				status: '',
			},

			rules: {
                status: [
					(v) => !!v || 'Statut obligatoire',
				]
			}
		}
	},

	computed: {
		projectStatuses: function() {
			return ProjectStatuses;
		}
	},

	methods: {
		onClose() {
			this.$eventHub.$emit('close-modal')
		},

        patchProjectsRec(index,projects,satus,callback) {
            if (projects.length === index ){
                callback();
            }else {
                projects[index].status = satus;
                this.axios.put('/api/projects/'+projects[index].id, {
                        status:projects[index].status
                    })
					.then(response => {
						this.patchProjectsRec(++index,projects,satus,callback)
					})
					.catch(err => {
                        console.log(err)
                        callback();
                    })
            }
        },

		onValidate() {
            this.patchProjectsRec(0,this.$store.state.datatable.projects.selected,
            this.model.status,()=>{
                this.$eventHub.$emit('close-modal');
                this.$eventHub.$emit('reload-list');
            });

		}
	}
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/views/projects/list/EditStatus.vue